// extracted by mini-css-extract-plugin
module.exports = {"card":"faq-module--card--eLF9a","container":"faq-module--container--qQhRo","topic":"faq-module--topic--12Ciz","link":"faq-module--link--2M8dC","toc":"faq-module--toc--QJVPi"};